import { Outlet } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

/**
 * CMS 應用外框 — 設計系統地基。
 *
 * 深色 Sidebar + 白底 TopBar + 內容區，三者皆由 index.css 之設計 token 驅動。
 * 各頁僅負責 <main> 內的內容，外框版型統一於此。
 */
export function AppLayout(): JSX.Element {
  return (
    <div className="app-shell">
      <Sidebar />
      <div className="app-body">
        <TopBar />
        <main className="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
